import { useQuery } from '@tanstack/react-query';
import { getContactCategoryById } from '../api/contactCategories';

export function useContactCategory(id: number | null) {
  return useQuery({
    queryKey: ['settings-contact-categories', id],
    queryFn: () => getContactCategoryById(id!),
    enabled: id !== null,
  });
}
